
export const STAR_RATING = "Rating";
export const TEXT_BOX = "TextBox";
